import {AbstractDTO} from "./abstract";

export class GadgetFilterDTO extends AbstractDTO {

    name: string;
    key: string;
    value: string;
    serverSide: boolean;

    constructor(attributes: Object) {
        super(attributes);
        this.name = attributes['name'] || '';
        this.key = attributes['key'] || '';
        this.value = attributes['value'] || '';
        this.serverSide = attributes['serverSide'] || false;
    }


    static createFromArray(collection: any): any[] {
        return (collection || []).map((attributes: object) => {
            return GadgetFilterDTO.create(attributes || {});
        });
    }

}